export default `Canny('identify', {
  appID: 'YOUR_APP_ID',
  user: {
    avatarURL: viewer.avatarURL, // optional
    companies: viewer.companies.map((company) => ({
      created: new Date(company.created).toISOString(), // optional
      id: company.id,
      monthlySpend: company.monthlySpend, // optional
      name: company.name,
    })),
    created: new Date(viewer.created).toISOString(), // optional
    email: viewer.email,
    id: viewer.id,
    name: viewer.name,
  },
});`;
